import React, {useRef} from 'react';
import {useTranslation} from "react-i18next";
import useSystemDateTheme from "../../../../hooks/useSystemDateTheme";
import OrderView from "../../orders/OrderView";
import {tabsIds} from "../../orders/OrderView/orderPage.types";
import {OrderInfoTab} from "../../orders/OrderView/tabs/OrderInfoTab";
import CourseMinutesTab from "../../orders/OrderView/tabs/CourseMinutesTab";
import SpeechesTab from "../../orders/OrderView/tabs/SpeechesTab";
import AdditionalAttachmentsTab from "../../orders/OrderView/tabs/AdditionalAttachmentsTab";
import {AdminTapActionsRef} from "../../orders/OrderView/UserTypeOrderView/CourseOrderAdminView";
import ExaminerCompleteOrderView from "../ExaminerCompletedOrderView";
import AboutCourseTab from "../../courses/CourseView/tabs/AboutCourseTab";
import {ReceiptBtn} from "../../orders/OrderView/UserTypeOrderView/CourseOrderAdminView/receiptBtn";
import {getUserSession} from "../../../../helpers/UserInfo";
import {hasRequiredRole} from "../../../../components/blocks/AuthGuard";
import {PublishingRoles} from "../../../../services/accountService/models/AccountType";

export const  CompletedCourseOrderTaskDetails =()=>{
    const submitRef = useRef<AdminTapActionsRef>(null);
    const { t } = useTranslation("Orders");
    const { toSystemThemeDateFormat } = useSystemDateTheme();
   const [open, setOpen] = React.useState<boolean>(false);
 
   
    return (
        <ExaminerCompleteOrderView
            breadcrumbs={({ serialNumber, orderId,serialGuid }) => [
                {
                    localizationKey: "completedTasks",
                    path: "/home/completedTasks",
                    menuItemId: "completedTasks",
                },
                {
                    localizationKey: "order-number",
                    path: `/home/examinerCompletedOrder/${serialGuid}`,
                    localizationParameters: { orderNumber: serialNumber },
                },
            ]}
            defaultTabId="info"
            leftSection={({ selectedTabId }) => {
                return  undefined;
            }}
            tapsToView={({ courseData, courseOrderData, openedTask, activePage, setActivePage, userType,setTriggerOrderUpdate }) => {
                let sections :any[] =[]
                if(hasRequiredRole(getUserSession()!.roles, ["PublishingAllOrdersRead"])) {
                    sections = [
                        "applicantInfoWithDetails",
                        "researchesCenter",
                        "refereeCenter",
                        "rewards",
                        "ISBNSection",
                        "procedures",
                    ];
                }
                else {
                    sections  = [
                        "researchesCenter",
                        "refereeCenter"
                    ]
                }


                return [
                    {
                        id: tabsIds.info,
                        title: t("info"),
                        content: (
                            <OrderInfoTab
                                setActivePage={setActivePage}
                                activePage={activePage}
                                activeSectionsIds={sections}
                                userType={userType}
                                courseOrder={courseOrderData}
                                course={courseData}
                                openedTask={openedTask}
                                submitRef={submitRef}
                                setTriggerOrderUpdate={setTriggerOrderUpdate}
                            />
                        ),
                    },
                    {
                        id: tabsIds.courseInfo,
                        title: t("aboutCourse"),
                        content: <AboutCourseTab course={courseData} />,
                    },
                ];
            }}
            userType="Admin"
            headersToView={({ courseOrderData }) =>
                !courseOrderData
                    ? []
                    : [
                        {
                            title: t("orderNumber"),
                            value: courseOrderData?.serialNumber ?? "",
                        },
                        {
                            title: t("applicationDate"),
                            value: toSystemThemeDateFormat("2024-01-01"), //TODO": return id
                        },
                        {
                            title: t("publicationTypeCategory"),
                            value: `${courseOrderData.typeOfScientific?.typeOfScientificDetail.displayName ?? ""} - ${
                                courseOrderData.scientificClassification?.scientificClassificationDetail?.displayName ?? ""
                            }`,
                        },
                        {
                            title: t("publicationLanguage"),
                            value: `${courseOrderData?.languageOfScientific.languageOfScientificDetail.displayName}`,
                        },
                        {
                            title: t("researchCenter"),
                            value: `${courseOrderData?.centreManagement?.displayName ?? ""}`,
                        },
                        {
                            title: t("numberOfPages"),
                            value: courseOrderData?.numberOfPages ?? 0,
                        },
                        {
                            title: t("publicationDate"),
                            value: toSystemThemeDateFormat(courseOrderData.submissionDate),
                        },
                        {
                            title: t("rewardReceipt"),
                            value: (
                                <ReceiptBtn t={t} courseOrderData={courseOrderData} open={open} setOpen={setOpen} />
                            ),
                        },
                    ]
            }

        />
    );
}